import { Link } from '@gassan-ui'
import { PreOwnedJewelsServiceContent } from '@lib/kontent/navigation-helpers/get-pre-owned-service-content'
import NextLink from 'next/link'
import { FC } from 'react'
import { HeaderImageColumn } from '../image-column'
import { HeaderLinkColumn } from '../link-column'

type HeaderShopMenuServiceProps = PreOwnedJewelsServiceContent

export const HeaderShopMenuService: FC<HeaderShopMenuServiceProps> = ({
  linkList,
  imageLinkColumn,
}) => {
  return (
    <>
      {linkList && (
        <HeaderLinkColumn
          title={linkList.title}
          readMoreLink={
            linkList.viewMore && (
              <NextLink href={linkList.viewMore.url} passHref>
                <Link variant="blue">{linkList.viewMore.label}</Link>
              </NextLink>
            )
          }
          links={linkList.links}
          linkSpace="regular"
        />
      )}
      {imageLinkColumn && <HeaderImageColumn {...imageLinkColumn} />}
    </>
  )
}
